<!--
 * @Description: 转移客户
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-09 09:11:58
 * @LastEditors: cxh
-->
<template>
  <a-modal
    v-model:visible="visible"
    :title="t('btn.transferCustomer')"
    width="670px"
    @ok="handleSubmit"
    :okText="t('btn.confirm')"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible">
      <a-form-item name="seller" :label="t('custom.SelectRecipient')" :rules="[{ required: true, message: t('common.pleaseSelect') }]">
        <user-select v-model:value="editForm.seller" :status="1" />
      </a-form-item>
      <a-form-item name="type" :label="t('common.remark')">
        <CosTextarea :placeholder="t('common.pleaseInput')" v-model:value="editForm.remark" :maxlength="2000" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { potentialTransfer } from '@/api/overseasSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const data = ref<PotentialItem[]>([])
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = defineEmits(['success'])
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { remark, seller, cosIdList } = editForm.value
    potentialTransfer({
      remark,
      cosIdList,
      seller
    })
      .then(() => {
        message.success(t('tips.ZCdvva'))
        emit('success')
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const toggle = (rows: PotentialItem[]) => {
  if (!rows || !rows.length) {
    message.warning(t('tips.chooseData'))
    return
  }
  data.value = rows
  const cosIdList = rows.map((item) => item.cosId)
  editForm.value = {
    cosIdList
  }
  visible.value = true
}

defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'transferModel' }
</script>
<style lang="scss" scoped>
.clueMerge {
  .list {
    margin: 20px 0;
    li {
      display: flex;
      align-items: center;
    }
    .name {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flex1 {
  flex: 1;
}
</style>
